<script setup lang="ts">
import PopupOverlay from '@/components/popup/PopupOverlay.vue';
import { useValidator } from '@/composables/useValidator';
import { RuleEnum } from '@/constants/enums/RuleEnum';
import authApi from '@/services/authApi';
import { computed, ref } from 'vue';
import SvgIcon from '../base/SvgIcon.vue';
import FormCard from './formElement/FormCard.vue';

const props = withDefaults(
  defineProps<{
    showClose?: boolean;
  }>(),
  {
    showClose: true
  }
);
const formChoose = defineModel('formChoose');
const showPopup = ref(false);
const phoneNumber = ref('');
const { errorMessage, handleValidate } = useValidator();

const correctFormat = computed(() => {
  return handleValidate(RuleEnum.Phone, phoneNumber.value);
});

const sentPhonenumber = () => {
  if (correctFormat.value && phoneNumber.value.trim() !== '') {
    authApi.forgetPassword(phoneNumber.value);
    showPopup.value = true;
  }
};

const hideMiddlePhonenumber = (number: string) => {
  return number.replace(/(\d{4})(\d{3})(\d{3})/, '$1-XXX-$3');
};

const handleClose = () => {
  formChoose.value = 'LoginForm';
  showPopup.value = false;
};
</script>

<template>
  <FormCard>
    <div class="title">
      <SvgIcon @click="formChoose = 'LoginForm'" color="grey" name="arrowLeft" />
      <p class="m-auto">忘記密碼</p>
      <SvgIcon v-if="props.showClose" @click="formChoose = ''" color="grey" name="cross" />
    </div>
    <p class="hint">帳號密碼會以簡訊方式發送至您註冊的手機</p>

    <div class="input-block">
      <p class="mb-2">手機號碼<span>*</span></p>
      <input
        :class="[!correctFormat ? 'incorrect-block' : '']"
        v-model="phoneNumber"
        type="text"
        placeholder="請輸入手機號碼"
        @keyup.enter="sentPhonenumber"
      />
      <p v-if="!correctFormat" class="error-hint">格式不正確</p>
    </div>

    <button @click="sentPhonenumber">送出</button>
    <PopupOverlay v-model:showPopup="showPopup">
      <div class="popup-confirm-card">
        <p class="popup-title">正在傳送中，請前往確認</p>
        <p class="popup-hint">您的帳號密碼將於幾分鐘內傳送至:</p>
        <p class="popup-hint">{{ hideMiddlePhonenumber(phoneNumber) }}</p>
        <button class="popup-btn" @click="handleClose">關閉</button>
      </div>
    </PopupOverlay>
  </FormCard>
</template>

<style scoped lang="scss">
.title {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  color: #000000cc;
  font-size: 18px;
  font-weight: 600;
}
.hint {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #00000066;
  font-size: 12px;
  margin: 4px 0 16px;
}
.input-block {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 16px;
  p {
    color: #19191999;
    font-weight: 600;
    display: flex;
    span {
      color: #ea4425;
    }
  }
  input {
    border: 1px solid #0000001a;
    border-radius: 4px;
    padding: 12px;
    font-size: 16px;
    color: $txt-color-grey-80;
    &.incorrect-block {
      border: 1px solid #ea4425;
    }
    &:focus {
      outline: none;
    }
  }
  .error-hint {
    color: #ea4425;
    font-size: 12px;
    margin-top: 4px;
  }
}
button {
  width: 100%;
  background-color: #3a3a3a;
  border-radius: 4px;
  height: 40px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.popup-confirm-card {
  width: 280px;
  background-color: #ffffff;
  box-shadow: 0px 1px 16px #00000029;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .popup-title {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    color: #000000cc;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 4px;
  }
  .popup-hint {
    width: 100%;
    color: #19191966;
    font-size: 14px;
    display: flex;
    align-items: center;
    line-height: 20px;
  }
  .popup-btn {
    margin-top: 16px;
    width: 100%;
    background-color: #f74768;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    border: none;
    &:focus {
      outline: none;
    }
  }
}
</style>
